import React from 'react';
import { useSelector } from 'react-redux';
import { Flex, Text } from 'rebass/styled-components';
import { Button } from '@getro/rombo';

import { impersonationSelector, userSelector } from '../../../redux/selectors';
import { useSignOut } from '../../../hooks/useSignOut';

// Shown when staff are impersonating a customer; Exit signs out the token.
export const ImpersonationBanner = () => {
  const { active, impersonator } = useSelector(impersonationSelector);
  const user = useSelector(userSelector);
  const { signOut, isLoading } = useSignOut();

  if (!active) {
    return null;
  }

  const targetName = [user?.firstName, user?.lastName].filter(Boolean).join(' ') || user?.email || 'this user';
  const actorName = impersonator?.name || impersonator?.email || 'a Getro admin';

  return (
    <Flex
      data-testid="impersonation-banner"
      alignItems="center"
      justifyContent="center"
      px={3}
      py={2}
      sx={{
        bg: '#92400E',
        color: 'white',
        gap: 3,
      }}
    >
      <Text fontSize={1} sx={{ textAlign: 'center' }}>
        You are viewing as <strong>{targetName}</strong> — impersonated by {actorName}.
      </Text>
      <Button variant="secondary" disabled={isLoading} onClick={signOut} data-testid="impersonation-exit">
        Exit
      </Button>
    </Flex>
  );
};

export default ImpersonationBanner;
